import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  class: "icon icon-tabler icon-tabler-businessplan h-6 w-6",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path stroke=\"none\" d=\"M0 0h24v24H0z\" fill=\"none\"></path><ellipse cx=\"16\" cy=\"6\" rx=\"5\" ry=\"3\"></ellipse><path d=\"M11 6v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4\"></path><path d=\"M11 10v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4\"></path><path d=\"M11 14v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4\"></path><path d=\"M7 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5\"></path><path d=\"M5 15v1m0 -8v1\"></path>", 7)
const _hoisted_9 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_9))
}
export default render